<template>
  <section>
    <b-card>
      <template #header>
        <div class="d-flex align-items-center">
          <span class="text-primary">Gestione Ubicazioni</span>
          <b-breadcrumb class="ml-2">
            <b-breadcrumb-item>
              <feather-icon
                icon="HomeIcon"
                scale="1.25"
                shift-v="1.25"
              ></feather-icon>
            </b-breadcrumb-item>
            <b-breadcrumb-item active> Elenco Ubicazioni</b-breadcrumb-item>
          </b-breadcrumb>
        </div>
        <div>
          <b-button variant="primary" @click="$refs.locationAddModal.open()">
            Aggiungi Ubicazione
          </b-button>
        </div>
      </template>

      <b-row class="mt-2">
        <b-col md="9"> </b-col>

        <b-col md="3">
          <div class="d-flex align-items-center mb-2">
            <span class="mr-1">Cerca</span>
            <b-form-input type="text" v-model="filter" size="md" />
          </div>
        </b-col>
      </b-row>

      <b-table
        :fields="fields"
        :items="locationsProvider"
        :busy="loading"
        :filter="filter"
        :current-page="currentPage"
        striped
        show-empty
        responsive
        @sort-changed="sortTable"
      >
        <template #table-busy>
          <div class="text-center text-primary-light my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Caricamento dati delle ubicazioni...</strong>
          </div>
        </template>

        <template #empty>
            <h5 class="text-primary-light text-center my-2">Non ci sono ubicazioni</h5>
        </template>

        <template #emptyfiltered>
          <h5 class="text-primary-light text-center my-2">Non sono stati trovati ubicazioni</h5>
        </template>

        <template #cell(codice)="data">
          {{ data.item.id_ditta}}
        </template>

        <template #cell(opzioni)="data">
          <feather-icon class="cursor-pointer" icon="EditIcon" size="20" @click="$refs.locationEditModal.open(data.item)" v-b-tooltip.hover.top.v-primary-light="'Modifica'"/>
        </template>

      </b-table>
    </b-card>

    <!-- Modali -->

    <location-add-modal ref="locationAddModal" @hide="getLocations"/>
    <location-edit-modal ref="locationEditModal" /> 

  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BBadge,
  BButton,
  BBreadcrumb,
  BBreadcrumbItem,
  BCard,
  BTable,
  BSpinner,
  BFormInput,
  VBTooltip,
} from "bootstrap-vue";

import { LocationAddModal, LocationEditModal } from "@/components/modals";

import { Requests } from "@/api";

export default {
  components: {
    BRow,
    BCol,
    BBadge,
    BButton,
    BBreadcrumb,
    BBreadcrumbItem,
    BCard,
    BTable,
    BSpinner,
    BFormInput,
    LocationAddModal,
    LocationEditModal,
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  data: () => ({
    fields: [
      {
        key: "nome_ubicazione",
        label: "Nome Ubicazione",
        sortable: true,
      },
      {
        key: "opzioni",
        sortable: false,
      },
    ],

    filter: null,
    sortBy: "nome_ubicazione",
    sortDesc: false,
    locations: [],

    //Helpers

    perPage: 10,
    currentPage: 1,
    loading: false,
  }),

  methods: {
    async getLocations(page) {
      this.loading = true;

      page = page ?? this.currentPage;

      let request_data = new FormData();

      request_data.append("offset", (page - 1) * this.perPage);
      request_data.append("limit", this.perPage);
      request_data.append("filter", this.filter);
      request_data.append("sortBy", this.sortBy);
      request_data.append("sortDesc", this.sortDesc);

      try {
        const response = await Requests.getLocations(request_data);
        this.locations = response;
      } catch (err) {
        console.debug(err);
      }

      this.loading = false;
    },

    async locationsProvider(ctx) {
      await this.getLocations();
      return this.locations.data;
    },

    async sortTable(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
    },
  },
};
</script>
